import _ from 'lodash'
import $ from 'cash-dom'
import {fmt, s, greyscale, palette, rewind, ffwd, cancel, offset, sfc32, quadMinMax, bezierMinMax} from './util.js'

export default class Galley{
  constructor(book){
    this.book = book
  }

  attach(dom){
    dom = $(dom).find('.diagram svg')
    let [width, height] = _.map(dom.attr('viewBox').split(' ').slice(2), _.toNumber)
    _.assign(this, {dom, width, height})

    return this
  }

  setDepth(depth){
    let {choices, endings, depth:maxDepth} = this.book.stats,
        pct = depth % 1,
        inv = 1 - pct,
        tendrils = []

    if (pct==0){
      this.dom.find(`.page`).css({display:null, opacity:null, stroke:null})
    }else{
      this.dom.find(`.page.depth-${Math.ceil(depth)}`).css({display:'block', opacity:pct, stroke:`rgba(255,255,255,${inv})`, strokeWidth:.25})
      this.dom.find(`.page:not(.depth-${Math.ceil(depth)}`).css({display:null, opacity:null, stroke:null})
    }
  }

  get svg(){
    let {book} = this
    let {illustrations, endings, choices, stats} = book

    let PG_WIDTH = 5,
        PG_HEIGHT = 8,
        PG_GUTTER = .25,
        PG_X_SKIP = 2 + PG_GUTTER,
        PG_Y_SKIP = 2,
        ILLO_INDENT = .5,
        DOT_R = .5,
        DOT_SKIP = 1.25,
        MAX_CHOICES = 4

    let width = 100,
        perRow = width / (PG_WIDTH+PG_X_SKIP/2 + PG_GUTTER),
        height = Math.ceil(book.pages/perRow) * (PG_HEIGHT + PG_Y_SKIP);

    let LEFT = PG_GUTTER/2,
        x = LEFT,
        y = 2

    let srcs = {},
        dsts = {}

    return `<svg class="galley" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">${
      _.flattenDeep([
        `<g>`,

        _.map(_.range(1, book.pages+1), pg => {
          if (pg==1){
            x += PG_WIDTH + PG_GUTTER
          }

          let illo = illustrations[pg],
              ends = _.includes(endings, pg),
              depth = stats.pages.depths[pg],
              side = pg%2 == 1 ? 'recto' : 'verso',
              elts = []

          if (depth==undefined){
            depth = stats.pages.depths[side=='recto' ? pg-1 : pg+1]
          }

          // console.log({pg, depth})
          // page outline fill
          elts.push(`<rect fill="#1a1a1a" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"></rect>`)
          dsts[pg] = {x:x+PG_WIDTH/2, y:y+PG_HEIGHT*.85}


          if (illo){
            let iX = x + ILLO_INDENT,
                iY = y + ILLO_INDENT,
                iW = PG_WIDTH - 2*ILLO_INDENT,
                iH = illo=='inline' ? (PG_HEIGHT/2 - ILLO_INDENT) : (PG_HEIGHT - 2*ILLO_INDENT),
                clr = '#333'
            if (illo=='spread'){
              iW += ILLO_INDENT
              if (side=='recto') iX -= ILLO_INDENT
              // clr = '#4a4a4a'
            }


            elts.push(`<rect fill="${clr}" x="${iX}" y="${iY}" width="${iW}" height="${iH}"/>`)

          }


          // if (illo){
          //   let iX = x + ILLO_INDENT,
          //       iY = y + ILLO_INDENT,
          //       iW = illo=='spread' ? (2*PG_WIDTH - 2*ILLO_INDENT) : (PG_WIDTH - 2*ILLO_INDENT),
          //       iH = illo=='inline' ? (PG_HEIGHT/2 - ILLO_INDENT) : (PG_HEIGHT - 2*ILLO_INDENT)
          //   if (!(illo=='spread' && side=='recto')){
          //     elts.push(`<rect title="illo-${illo}" fill="#444" x="${iX}" y="${iY}" width="${iW}" height="${iH}"/>`)
          //   }
          // }

          if (ends){
            let eX = x + PG_WIDTH/2,
                eY = y + PG_HEIGHT*.65,
                eR = PG_WIDTH/4
            // elts.push(`<ellipse fill="none" stroke="skyblue" stroke-width=".4" cx="${eX}" cy="${eY}" rx="${eR}" ry="${eR}" />`)
            elts.push(`<rect fill="skyblue" stroke-width=".4" x="${eX}" y="${eY}" width="${eR}" height="${eR}" transform="rotate(45 ${eX} ${eY})"/>`)
          }


          let dotX = x + PG_WIDTH/2,
              dotY = y + PG_HEIGHT*(ends ? .8125 : .85),
              numDots = Math.min(_.size(choices[pg]), MAX_CHOICES),
              dotR = numDots > 1 ? DOT_R : DOT_R*.75

          // if (numDots==1){
          //    srcs[choices[pg][0]] = {x:dotX, y:dotY}
          // }

          // if (numDots>1) _.times(numDots, (i) => {
          //   let fill = palette(1 - _.min([.25*(numDots-1), .8])),
          //       stroke = 'none'

          //   // let fill = numDots==1 ? 'none' : palette(1 - .2*(numDots-1)), //'red',
          //   //     stroke = numDots==1 ? 'rgba(255,255,255,0.6)' : 'none'

          //   elts.push(`<ellipse fill="${fill}" stroke="${stroke}" stroke-width=".2" cx="${dotX}" cy="${dotY}" rx="${dotR}" ry="${dotR}" />`)

          //   srcs[choices[pg][i]] = {x:dotX, y:dotY}

          //   dotY -= DOT_SKIP
          // })

          dotR -= DOT_R*.25
          dotY -= PG_HEIGHT*.1
          if (numDots>1) _.times(numDots, (i) => {
            let clr = palette(1 - _.min([.25*(i), .8]))
            if (i==0){
              elts.push(`<ellipse fill="${clr}" stroke="${clr}" stroke-width=".55" cx="${dotX}" cy="${dotY}" rx="${dotR}" ry="${dotR}" />`)
            }else{
              elts.push(`<ellipse fill="none" stroke="${clr}" stroke-width=".55" cx="${dotX}" cy="${dotY}" rx="${dotR}" ry="${dotR}" />`)
            }
            dotR += DOT_R
          })


          // // page outline stroke
          // elts.push(`<rect fill="none" stroke-width=".25" stroke="#fff" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)



          x += PG_WIDTH + PG_GUTTER
          if (pg%2 == 1){
            x += PG_X_SKIP

            if (x + 2*PG_WIDTH+PG_GUTTER > width){
              x = LEFT
              y += PG_HEIGHT + PG_Y_SKIP
            }
          }



          elts.unshift(`<g class="page depth-${depth}">`)
          elts.push(`<title>pg. ${pg}</title>`)
          elts.push('</g>')

          return elts

        }),



        // _.map(srcs, (src, pg) => {
        //   let dst = dsts[pg]
        //   console.log(src, pg, dst)

        //   return `<path stroke="rgba(255,255,255,0.2)" stroke-width=".4" d="M ${src.x} ${src.y} L ${dst.x} ${dst.y}"/>`

        //   // let r = Math.sqrt(Math.pow(src.x-dst.x, 2) + Math.pow(src.y-dst.y, 2))/2
        //   // return `<path fill="none" stroke="rgba(255,255,255,0.2)" stroke-width=".4" d="M ${src.x} ${src.y} A ${r} ${r} 0 1 1 ${dst.x} ${dst.y}"/>`

        //   // return `<path fill="none" stroke="rgba(255,255,255,0.2)" stroke-width=".4" d="M ${src.x} ${src.y} C ${src.x + 1*PG_WIDTH} ${src.y+PG_HEIGHT*.5} ${dst.x-1*PG_WIDTH} ${dst.y+PG_HEIGHT*.5} ${dst.x} ${dst.y}"/>`

        // })

        '</g>'

      ]).join('')
    }</svg>`
  }
}
